import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';

import withFormItem from './withFormItem';
import withFormikField, { formFieldPropTypes } from './withFormikField';

@withFormItem
export class DatePickerComponent extends Component {
    static propTypes = {
        ...formFieldPropTypes,
        disabled: PropTypes.bool,
        placeholder: PropTypes.string,
        disabledDate: PropTypes.func,
        dateOnly: PropTypes.bool
    };

    onChange = date => {
        if (!date) {
            this.props.onChange(null);
            return;
        }

        const next = this.props.dateOnly
            ? moment.utc([date.year(), date.month(), date.date()])
            : moment.utc(date).startOf('day');

        this.props.onChange(next);
    }

    render() {
        const { value, placeholder, disabledDate, disabled, dateOnly } = this.props;
        const momentValue = value
            ? (dateOnly ? moment.utc(value) : moment(value))
            : undefined;

        return (
            <DatePicker
                value={momentValue}
                placeholder={placeholder}
                onChange={this.onChange}
                getPopupContainer={trigger => trigger.parentNode}
                disabled={disabled}
                disabledDate={disabledDate} />
        );
    }
}

export default withFormikField(DatePickerComponent);
